import {request} from "../request/request";

const signUp = {
  postOne: (data) => request.create('/sign-up', data),
};

export {signUp};